import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { Swiper as SwiperInstance } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import Tab, { TabProps } from '@/components/molecules/tab/tab';
import SwipeItems from '@/components/utilities/swipe-items/swipe-items';
import styles from './tab-menu.module.scss';

export interface TabMenuProps {
  /** The active item to mark */
  activeItem: {
    type: 'id' | 'url';
    value?: string | null;
  };
  /** The class name to apply */
  className?: string;
  /** The tabs to display in the menu */
  tabs: TabProps[];
}

const TabMenu = ({ activeItem, className, tabs }: TabMenuProps) => {
  const swiperRef = useRef<SwiperInstance>();

  useEffect(() => {
    if (!swiperRef.current) return;

    const slideIndex = tabs.findIndex(
      tab => activeItem.value === (activeItem.type === 'id' ? tab.id : tab.url),
    );

    if (slideIndex !== -1) {
      swiperRef.current.slideTo(slideIndex);
    }
  }, [activeItem, tabs, swiperRef]);

  return (
    <SwipeItems
      className={classNames(styles.component, className)}
      swiperRef={swiperRef}
    >
      {tabs.map(({ id, ...tab }, tabIndex) => {
        const isActive =
          activeItem.value === (activeItem.type === 'id' ? id : tab.url);

        return (
          <SwiperSlide key={tabIndex} className={styles.slide}>
            <Tab {...tab} isActive={isActive} />
          </SwiperSlide>
        );
      })}
    </SwipeItems>
  );
};

TabMenu.displayName = 'TabMenu';

export default TabMenu;
